import { loginApi } from '@/api/common.js'
import { unRead } from '@/api/control.js'
import { getToken, removeAll, setToken, setMobile, getMobile ,setEmail} from "@/utils/cookies"
import { ElMessage } from 'element-plus'
import { Encrypt } from '@/utils/crypt.util.js'
import { h } from 'vue'
const t =  require('@/lang/index.js').default.global.t

const user = {
    state: () => {
        return {
            token: getToken(),
            islogin: getToken() ? true : false,
            mobile: getMobile,
            unReadnum: 0
        }
    },
    mutations: {
        handleLogin(state, data) {
            state.islogin = data
        },
        handleUnReadNum(state, data) {
            state.unReadnum = data
        }
    },
    actions: {
        //获取用户消息未读数量
        getUserUnReadNum({ commit }) {
            unRead().then(res => {
                console.log('用户未读数量', res);
                if (res.code == 200) {
                    commit('handleUnReadNum', res.result)
                }
            }).catch(err => { console.log(err); })
        },
        //登录
        login({ commit, getters ,dispatch }, { data, router }) {
            loginApi({ ...data, password: Encrypt(data.password) }).then(res => {
                if (res.code == 200) {
                    setToken(res.result.token)
                    setMobile(res.result.mobile)
                    setEmail(res.result.email)
                    commit('handleLogin', true)
                      if (JSON.stringify(getters.getProductStateRouter) !== '{}') {
                        router.push(getters.getProductStateRouter)
                        dispatch('setPath',{})
                      }else{
                        // let { default: i18n } = require('@/i18n')
                        let mes = ElMessage({
                            message: h('div', { class: ['custom-login'] }, h('div', { style: { textAlign: 'center' } }, [h('img', {
                                src: require('@/assets/image/sucess.png'), style: { width: '150px', height: '150px' }
                            }), h('div', { class: 'logintext' }, t("login.loginSuccess"))])),
                            customClass: "custom-login1",
                            duration: 1000
                        })
                        setTimeout(() => {
                            mes.close()
                        }, 1000);
                        router.push('/home/find')
                      }
                    
                }
            })
        },
        //退出登录
        logOut({ commit }) {
            removeAll()
            commit('handleLogin', false)
        }
    },
    getters: { getProductStateRouter: (state, getters, rootState) => rootState.product.lastVisitPathRouter }
}
export default user
